var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBullet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 6,
  fill: "#1FDAFF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 9.5,
  stroke: "#03B9DD",
  strokeOpacity: 0.15,
  strokeWidth: 7
})));
export default SvgBullet;